import type { MailboxInfo } from "owa-client-types";
import { getAccountKeyForMailboxInfo } from "owa-client-types";
import getStore from "../store/store";
import type { GeneralPreferences } from "../store/store";
import { trace } from "owa-trace";

export function saveGeneralPreferences(mailboxInfo: MailboxInfo, preferences?: GeneralPreferences): void {
    if (preferences) {
        const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
        const existingPreferences = getStore().copilotGeneralPreferencesMap.get(accountKey);
        if (existingPreferences) {
            trace.info(`Existing isCopilotUIDisabled: ${existingPreferences.isCopilotUIDisabled}`);
            trace.info(`Existing isMCPEnabled: ${existingPreferences.isMCPEnabled}`);
        }
        trace.info(`New isCopilotUIDisabled: ${preferences?.isCopilotUIDisabled}`);
        trace.info(`New isMCPEnabled: ${preferences?.isMCPEnabled}`);
        getStore().copilotGeneralPreferencesMap.set(accountKey, {
            isCopilotUIDisabled: preferences?.isCopilotUIDisabled,
            isMCPEnabled: preferences?.isMCPEnabled,
        });
    }
}
